<template>
<div class="chapter">
<div class="inner_page">
<div class="alsoby">
<a id="title3"></a><div class="title-alsoby">Books by Elizabeth Beverly</div>
<div class="p"><span>Silhouette Desire</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span><em class="i">An Unsuitable Man for the Job</em> #724 <br/><em class="i">Jake’s Christmas</em> #753 <br/><em class="i">A Lawless Man</em> #856 <br/>*<em class="i">A Dad Like Daniel</em> #908 <br/>*<em class="i">The Perfect Father</em> #920 <br/>*<em class="i">Dr. Daddy</em> #933 <br/><em class="i">†</em><em class="i">Father of the Brat</em> #993 <br/><em class="i">†</em><em class="i">Father of the Brood</em> #1005 <br/><em class="i">†</em><em class="i">Father on the Brink</em> #1016 <br/><em class="i">*</em><em class="i">Roxy and the Rich Man</em> #1053 <br/><em class="i">*</em><em class="i">Lucy and the Loner</em> #1063</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span>*From Here to Maternity <br/>†From Here to Paternity <br/>‡The Family McCormick</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Silhouette Special Edition</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p-br"><span><em class="i">Destinations South</em> #557 <br/><em class="i">Close Range</em> #590 <br/><em class="i">Donovan’s Chance</em> #639 <br/><em class="i">Moriah’s Mutiny</em> #676 <br/><em class="i">Up Close</em> #737 <br/><em class="i">Hired Hand</em> #803 <br/><em class="i">Return Engagement</em> #844</span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459271517_als01.vue?52fd6fe5